import { useEffect } from "react"
import { SUPPORT_EMAIL } from "helpers/constants"
import particlesConfig from "./particlesConfig.json"
import "./error.scss"

export default function ErrorPage() {
  useEffect(() => {
    window.particlesJS("particles-js", particlesConfig)
  }, [])

  return <div className="ErrorPage-wrapper">
    <div id="particles-js" />
    <div className="ErrorPage">
      <div className="content">
        <div className="title">404</div>
        <div className="subtitle">This is not the page you were seeking.</div>
        <div className="message">Please contact <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> for support.</div>
      </div>
    </div>
  </div>
}
